export const ROUTE_PATHS = {
  HOME: '/',
  ABOUT: '/about-us',
  CONTACT: '/contact-us',
  PRODUCT: '/products',
  LOGIN: '/login',
  REGISTER: '/register',
  FEATURE: '/feature',
  ITEMS: '/items',
};

export const LOCAL_STORAGE = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
};
